import React from "react";

const AuthNavButtons = ({
  loggedIn,
  subscribed,
  actionLoading,
  onSubscribe,
  onUnsubscribe,
  onLogin,
  onLogout,
  itemClassName,
  activeClassName = "",
}) => {
  const subscribeLabel = subscribed ? "Unsubscribe" : "Subscribe";
  const authLabel = loggedIn ? "Logout" : "Login";

  const handleSubscribeClick = () => {
    if (subscribed) {
      onUnsubscribe();
      return;
    }
    onSubscribe();
  };

  const handleAuthClick = () => {
    if (loggedIn) {
      onLogout();
      return;
    }
    onLogin();
  };

  return (
    <>
      <button
        type="button"
        className={`${itemClassName} ${activeClassName}`}
        onClick={handleSubscribeClick}
        disabled={actionLoading}
      >
        {actionLoading ? "Please wait..." : subscribeLabel}
      </button>

      <button
        type="button"
        className={itemClassName}
        onClick={handleAuthClick}
        disabled={actionLoading}
      >
        {authLabel}
      </button>
    </>
  );
};

export default AuthNavButtons;
